import React, { forwardRef } from "react";
import "./NotificationCard.scss";

/**
 * Componente NotificationCard que muestra un elemento de notificación individual con un icono,
 * título, subtítulo, marca de tiempo e indicador visual para notificaciones recientes.
 *
 * @param {string|number} idNotificacionUsuario - Identificador único para la notificación
 * @param {React.Component} icon - Componente de icono a mostrar
 * @param {string} icono - Nombre del icono (usado con DynamicIcon)
 * @param {string} titulo - Título de la notificación
 * @param {string} descripcion - Descripción de la notificación
 * @param {string} time - Marca de tiempo o descripción de tiempo
 * @param {boolean} isRecent - Si la notificación es reciente (afecta el estilo)
 * @param {Function} onClose - Función callback para manejar el cierre
 * @returns {JSX.Element} La tarjeta de notificación renderizada
 */
export const NotificationCard = forwardRef(({
  idNotificacionUsuario,
  icon,
  icono,
  titulo,
  descripcion,
  time,
  isRecent,
  onClose,
}, ref) => {
  const IconComponent = icon;

  return (
    <div ref={ref} key={idNotificacionUsuario} className="notification-card">
      <div className="notification-card__indicator">
        <div
          className={`notification-card__dot ${
            isRecent ? "notification-card__dot--recent" : ""
          }`}
        ></div>
      </div>
      <div className="notification-card__icon">
        <IconComponent iconName={icono} />
      </div>
      <div className="notification-card__content">
        <h3 className="notification-card__title">{titulo}</h3>
        <span
          className="notification-card__description"
          dangerouslySetInnerHTML={{ __html: descripcion }}
        />
        <span className="notification-card__time">{time}</span>
      </div>
    </div>
  );
});
